const multipleSplitComponent = document.querySelectorAll('.split--multiple')

multipleSplitComponent.forEach((component) => {
  const childComponents = component.querySelectorAll(':scope > .component')
  let prevComponentBgClass = ''

  childComponents.forEach((childComponent, i) => {
    const childComponentBgClass =
      [...childComponent.classList].filter((cl) =>
        /bg-colour-+[a-z]+-/.test(cl)
      )[0] || ''

    if (i > 0 && childComponentBgClass === prevComponentBgClass) {
      // Remove spacing at top of component if previous component has the same background tint class
      childComponent.style.paddingTop = 0
    }

    // Set previous background class to current background class for next component check
    prevComponentBgClass = childComponentBgClass
  })
})
